'use client';

import React from 'react';
import { Container } from 'components/shared';
import { analytics } from 'lib/analytics/analytics';
import { useTranslations } from 'next-intl';
import { BuyNowButton } from 'components/shared/CTAComponent';
import { getLesMillsContent } from './content';
import { LES_MILLS_TRACKING } from './tracking';
import useLesMillsPricing from './useLesMillsPricing';
import styles from './Optimize.module.css';

const Optimize = () => {
  const t = useTranslations('uhXLesMills');
  const { optimize, hero } = React.useMemo(() => getLesMillsContent(t), [t]);
  const { bundlePriceDisplay } = useLesMillsPricing();
  const handleOptimizeBuyCtaClick = () => {
    analytics.track(LES_MILLS_TRACKING.cta.optimize.event, {
      page: LES_MILLS_TRACKING.page,
      cta: 'optimize',
    });
  };

  return (
    <section
      className={styles.section}
      role="region"
      aria-labelledby="lm-optimize-heading"
    >
      <div className={styles.visual} aria-label={t('a11y.optimizeVisualLabel')}>
        <div
          className={styles.banner}
          aria-hidden="true"
          style={
            {
              ['--optimize-banner' as string]: `url(${optimize.banner})`,
            } as React.CSSProperties
          }
        />
        <div className={styles.overlay}>
          <Container>
            <div className={styles.content}>
              <div className={styles.stack}>
                <h2 className={styles.title} id="lm-optimize-heading">
                  {optimize.title}
                </h2>
                <BuyNowButton
                  className={`${styles.heroBuyNowButton} gtm`}
                  href={hero.ctaHref}
                  data-buttontype={LES_MILLS_TRACKING.cta.optimize.dataButtonType}
                  onClick={handleOptimizeBuyCtaClick}
                  aria-label={t('a11y.buyBundleCtaAriaLabel', {
                    price: bundlePriceDisplay,
                  })}
                >
                  {t('common.buyBundleFor', { price: bundlePriceDisplay })}
                </BuyNowButton>
              </div>
            </div>
          </Container>
        </div>
      </div>
      <div className={styles.bottomNoteBar}>
        <Container>
          <p className={styles.bottomNote}>{optimize.disclaimer}</p>
        </Container>
        <div className={styles.separator} />
      </div>
    </section>
  );
};

export default Optimize;
